import { observable } from "mobx";
import { Type } from "class-transformer";
import RefundApprovalResponse from "./refundApprovalResponse";
import RefundChargeResponse from "./refundChargeResponse";
import type { IRefund } from "./types";
import RefundPermittedActionsResponse from "./refundPermittedActionsResponse";
import TransferPaymentType from "./transferPaymentType";
import RefundOriginalPayGatePaymentResponse from "./refundOriginalPayGatePaymentResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class PayGateToTransferRefundResponse {
  id!: string;

  @observable
  refundPaymentTemplateId!: string;

  @observable
  refundAmount!: number;

  @observable
  @Type(() => RefundChargeResponse)
  charge?: RefundChargeResponse;

  @observable
  @Type(() => RefundPermittedActionsResponse)
  permittedActions!: RefundPermittedActionsResponse;

  @observable
  @Type(() => RefundApprovalResponse)
  approvals!: RefundApprovalResponse[];

  @observable
  officialRecordId?: string;

  @observable
  transferType!: TransferPaymentType;

  @observable
  @Type(() => RefundOriginalPayGatePaymentResponse)
  originalPayment!: RefundOriginalPayGatePaymentResponse;

  @observable
  payGatePaymentIdent?: string;
}

export default class PayGateToTransferRefund extends PayGateToTransferRefundResponse implements IRefund {
  @observable
  @Type(() => RefundApprovalResponse)
  approvals: RefundApprovalResponse[] = [];

  @observable
  isSelectable: boolean;
}
